<template>
  <v-layout class="inner-pages" column :style="{height: $store.getters.getAppHeight + 'px'}">
    <Header :header-height="$auth.check() ? '70px': '120px'" />

    <scroll-data>
      <Program52 v-if="gameId === 52"/>
      <Program62 v-if="gameId === 62"/>
      <Program59 v-if="gameId === 59"/>
      <Program63 v-if="gameId === 65"/>
      <Program68 v-if="gameId === 68"/>
    </scroll-data>
    <v-btn
      v-if="scrolled > 200"
      fixed
      dark
      small
      fab
      bottom
      right
      color="blue"
      @click.prevent="$vuetify.goTo('#link-index-certificate-program')"
    >
      <span class="notranslate"><v-icon>arrow_upward</v-icon></span>
    </v-btn>
  </v-layout>

</template>

<script>
  import Header from '../../../layouts/Header'
  import ScrollData from '../../../ScrollData'
  import Program59 from './Program59'
  import Program52 from './Program52'
  import Program62 from './Program62'
  import Program63 from './Program63'
  import Program68 from './Program68'
  export default {
    name: 'CertificateProgram',
    components: {Program59, Program52, Program62, Program63, Program68, ScrollData, Header},
    props: {
    },
    data: () => ({
      offsetTop: 0,
      scrollHeight: 0,
      scrolled: 0,
      gameId: process.env.GAME_ID
    }),
    computed: {
      appHeight: {
        get: function () {
          return this.scrollHeight
        },
        set: function (height) {
          this.scrollHeight = height
        }
      },
      styleObj () {
        const height = this.appHeight
        return {
          'height': height + 'px!important',
          // 'padding-top': '0!important',
          'padding-left': '20px!important',
          'padding-right': '20px!important',
          'overflow': 'auto'
        }
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    mounted () {
      this.scrollHeight = this.$store.getters.getAppHeight - 190
    },
    methods: {
      goTo (elem) {
        const element = document.getElementById(elem)
        element.scrollIntoView({behavior: 'smooth'})
      },
      handleScroll () {
        this.scrolled = window.scrollY
      },
      onScroll (e) {
        const top = e.target.scrollTop
        if (top > 300) {
          this.header = false
          this.appHeight = this.$store.getters.getAppHeight
        } else {
          this.header = true
          this.appHeight = this.$store.getters.getAppHeight - 190
        }
      }
    }
  }
</script>

<style lang="stylus">
@import '../../../../../node_modules/vuetify/src/stylus/main.styl';
ol ol {
  list-style: lower-alpha;
}
ul.go-to-links > li{
  color: $blue.darken-1;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/guest/CertificateProgram/index.vue